module.exports = __webpack_public_path__ + "images/24df6bb311616a711ace5f2e4edc7660-error.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.jpg
// module id = ./src/assets/images/error.jpg
// module chunks = 0